import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
// import breakpointsFunc from 'src/styles/breakpointsFunc';

const useStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  contentBody: {
    backgroundColor: palette.shades[100]
  },
  primaryContentBody: {
    padding: '24px 24px 0'
  },
  secondaryContentBody: {
    padding: '12px 24px 0'
  },
  headerSection: {
    padding: '12px 0 12px '
  },
  secondarySameAsPrimary: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '12px',
    cursor: 'pointer',
    '&:last-child': {
      marginBottom: '0',
      paddingBottom: '12px'
    }
  },
  avatar: {
    backgroundColor: palette.info.main,
    border: '1px solid',
    borderRadius: '50%',
    color: palette.common.white,
    height: '36px',
    width: '36px',
    fontSize: '18px',
    lineHeight: '34px',
    fontFamily: palette.fontFamilies.poppins,
    fontWeight: '600',
    textAlign: 'center',
    marginRight: '10px',
    flexShrink: '0'
  },
  teamMember: {
    alignItems: 'center',
    '&:not(:last-child)': {
      borderBottom: "1px solid ".concat(palette.shades[400])
    },
    display: 'flex',
    fontFamily: palette.fontFamilies.poppins,
    padding: '12px 20px',
    justifyContent: 'space-between'
  },
  teamMemberInfo: {
    display: 'flex',
    alignItems: 'center',
    width: '100%'
  },
  teamMemberListItemContactInfo: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between'
  }
}));
export default useStyles;